export default __webpack_public_path__ + "static/media/weihnachtsmarkt.f1128086.png";